// Shopify App Bridge CDN integration: use the current global API for a fresh token per request.
const getCurrentSessionToken = async () => {
  if (!window.shopify?.idToken) {
    throw new Error('Shopify embedded session is unavailable');
  }
  return window.shopify.idToken();
};

// Wrap fetch to include a fresh short-lived session token on every request
export async function authFetch(input, init = {}) {
  try {
    const token = await getCurrentSessionToken();
    const headers = new Headers(init.headers || {});
    headers.set('Authorization', `Bearer ${token}`);
    return fetch(input, {...init, headers});
  } catch (error) {
    console.warn('Failed to get Shopify session token, using the existing request fallback:', error);
    return fetch(input, init);
  }
}
